import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { getProviders } from '../services/providers.service';

import 'swiper/css';

function ProvidersShowcase() {
  const [providers, setProviders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let canceled = false;

    const fetchProviders = async () => {
      setIsLoading(true);

      const { data } = await getProviders();
      if (canceled) return;

      setProviders(data);
      setIsLoading(false);
    };

    fetchProviders();
    return () => {
      canceled = true;
    };
  }, []);

  const hasProviders = providers && providers.length > 0;

  return (
    <section className="mt-5">
          <div style={{minWidth: 0}}>
            <p className="fw-semibold m4-5" style={{color: 'var(--color-text-dark)', fontSize: '0.95rem'}}>
              Trabajamos con
            </p>
          </div>
      <div className="bg-white border border-grey rounded-4 shadow-sm p-2">
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-1">
          <div className="flex-grow-1 w-100">
            {isLoading ? (
              <div className="d-inline-flex align-items-center gap-2 text-muted">
                <Spinner animation="border" size="sm" role="status" />
                <small>Cargando entidades...</small>
              </div>
            ) : hasProviders ? (
              <div className="providers-carousel">
                  <Swiper
                    modules={[Autoplay]}
                    slidesPerView={3}
                    spaceBetween={16}
                    loop={true}
                    loopedSlides={providers.length}
                    slidesPerGroup={1}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    speed={360}
                    breakpoints={{
                      0: { slidesPerView: 2, spaceBetween: 8 },
                      576: { slidesPerView: 3, spaceBetween: 12 },
                      768: { slidesPerView: 2, spaceBetween: 14 },
                      992: { slidesPerView: 4, spaceBetween: 16 }
                    }}
                  >
                  {providers.slice(0, 5).map((provider) => (
                    <SwiperSlide key={provider._id || provider.id || provider.code || provider.name}>
                      <div className="providers-carousel__item text-center">
                        <div className="providers-carousel__logo">
                          {provider?.logoUrl ? (
                            <img src={provider.logoUrl} alt={provider?.name || 'Entidad financiera'} />
                          ) : (
                            <span className="fw-bold" style={{color: 'var(--color-accent, #d2006b)'}}>
                              {provider?.name?.slice(0, 2)?.toUpperCase() || 'EN'}
                            </span>
                          )}
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            ) : (
              <small className="text-muted">Pronto vas a ver las entidades con las que trabajamos.</small>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProvidersShowcase;
